import React, { useContext, useState } from 'react';
import { MdDeleteOutline } from 'react-icons/md';
import { AuthContext } from '../../../../shared/context/auth-context';

import './nomItem.css';
const NomItem = ({num, id, title, type, description, price}) => {
  const auth = useContext(AuthContext)
  const [bookData, setBookData] = useState([])

  // DELETE BOOK
  const deleteHandler = async (bookId) => {
    const confirm = window.confirm(`Are you sure to delete book name ${title}!`);
    
    if(!confirm) {
      return;
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/books/${bookId}`, {
        method: 'DELETE',
      });
   
      const responseData = await response.json();
      setBookData(responseData);

      if(!response.ok){
        throw new Error('Could not deleted book provided id')
      }
    } catch (err) {
      console.error('Could not delete book!', err.message)
    }
    
  }
  return (
    <tr>
      <td onClick={() => alert('Payment function will be show up here')}>{num}<span style={{display: 'none'}}>{id}</span></td>
      <td id='title' onClick={() => alert('Payment function will be show up here')}>{title}</td>
      <td id='type' onClick={() => alert('Payment function will be show up here')}>{type}</td>
      <td onClick={() => alert('Payment function will be show up here')}>{description}</td>
      <td onClick={() => alert('Payment function will be show up here')}>₮{price}</td>
      {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (
        <td>
          <div id='deleteEdit'>
            <MdDeleteOutline 
              className='delete'
              onClick={() => deleteHandler(id)}
            />
            <p>/ Edit</p>
          </div>
          
      </td>
      )}
      
    </tr>        
  )
}
export default NomItem;